const constant = {
  API:{
    url:"https://api-ap-northeast-1.graphcms.com/v2/cl4240jkh3qy001xj3xpb3p2l/master"
  }  
}

export default constant;